export default "__VITE_ASSET__KZBEzi9c__"